import { DataTable } from "@/components/Base/Datatable";
import { ContainerMetricsRow } from "@/lib/containerMetricsMath";
import { containerMetricsColumns } from "./ContainerMetricsTable.columns";

const columns = containerMetricsColumns();

export const ContainerMetricsTable = ({
  rows,
}: {
  rows: ContainerMetricsRow[];
}) => {
  return (
    // Recolor this table's borders (header and rows) to slate-700; the outer
    // container border comes from DataTable's own containerClassName.
    <div className="[&_thead]:border-slate-700 [&_tr]:border-slate-700">
      <DataTable
        columns={columns}
        data={rows}
        containerClassName="border-slate-700"
        hidePagination
        hideColumnsButton
      />
    </div>
  );
};
